import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { G as GridBox } from './Grid.styles-un2pb9nZ.js';

const Grid = ({
  children,
  inline = false,
  columns,
  rows,
  areas,
  alignItems,
  justifyItems,
  placeItems,
  alignContent,
  justifyContent,
  placeContent,
  autoColumns,
  autoRows,
  autoFlow,
  rowGap,
  columnGap,
  gap = 'none',
  padding = 'none',
  paddingBlockEnd,
  paddingBlockStart,
  paddingInlineEnd,
  paddingInlineStart,
  ...rest
}) => /*#__PURE__*/React__default.createElement(GridBox, _extends({}, rest, {
  $inline: inline,
  $columns: columns,
  $rows: rows,
  $alignItems: alignItems,
  $justifyItems: justifyItems,
  $placeItems: placeItems,
  $alignContent: alignContent,
  $justifyContent: justifyContent,
  $placeContent: placeContent,
  $autoColumns: autoColumns,
  $autoRows: autoRows,
  $autoFlow: autoFlow,
  $rowGap: rowGap,
  $columnGap: columnGap,
  $gap: gap,
  padding: padding,
  paddingBlockEnd: paddingBlockEnd,
  paddingBlockStart: paddingBlockStart,
  paddingInlineEnd: paddingInlineEnd,
  paddingInlineStart: paddingInlineStart,
  square: true
}), children);

export { Grid as G };
//# sourceMappingURL=Grid-B_1HddOo.js.map
